import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VBtn,{class:_vm.color ? 'ml-2 white--text' : 'ml-2',attrs:{"depressed":"","small":!_vm.medium,"color":_vm.color,"outlined":_vm.outlined,"block":_vm.block,"loading":_vm.loading,"disabled":_vm.disabled},on:{"click":_vm.press}},[_vm._v(" "+_vm._s(_vm.text)+" "),_c(VIcon,{attrs:{"right":""}},[_vm._v(_vm._s(_vm.icon))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }